import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class AttendanceStatisticsApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'attendanceStatistics'
    }

    
    /**
   * 根据userId获取当前用户信息
   * @param params
   */
  public getWorkingHoursStatistics(userId) {
    return this.send({userId: userId}, "workingHoursStatistics", this.Methods.GET)
  }

    /**
   * 获取迟到日期
   * @param params
   */
    public getLateNumber(lateDateDto) {
      return this.send(lateDateDto, "lateNumber", this.Methods.POST)
    }

    /**
   * 根据日期获取考勤记录
   * @param params
   */
  public getAttendanceRecord(now,userId) {
    return this.send({now: now,userId: userId}, "attendanceRecord", this.Methods.GET)
  }

  /**
   * 获取原始数据
   * @param params
   */
  public getOriginalData(now,userId) {

    // console.log('xxbb',now,userId);
    
    return this.send({now: now,userId: userId}, "originalData", this.Methods.GET)
  }

  /**
   * 异常反馈
   * @param params
   */
  public SaveAbnormalFeedback(attendanceResult) {
    console.log('xxbb',attendanceResult);
    
    return this.send(attendanceResult, "abnormalFeedback", this.Methods.POST)
  }

  /**
   * 管理层部门考勤统计
   * @param params
   */
  public getDepartmentAttendance(userId) {
    return this.send(userId, "departmentAttendance", this.Methods.POST)
  }

  /**
   * 高层统计
   */
  public getLeadershipStatistics(now,userId) {
    return this.send({now: now,userId: userId},"leadershipStatistics", this.Methods.GET)
  }

  /**
   * 外出天
   * @param params
   */
  public getLeaveDays(LeaveDaysDto) {
    return this.send(LeaveDaysDto, "leaveDays", this.Methods.POST)
  }

  /**
   * 出差
   * @param params
   */
  public getEvectionNumber(LeaveDaysDto) {
    return this.send(LeaveDaysDto, "evectionNumber", this.Methods.POST)
  }

  /**
   * 请假
   * @param params
   */
  public getDaysAway(LeaveDaysDto) {
    return this.send(LeaveDaysDto, "daysAway", this.Methods.POST)
  }


  /**
   * 考勤年度统计功能
   * @param params
   */
  public annualAttendanceStatistics(param) {
    return this.send(param, "AnnualAttendanceStatistics", this.Methods.GET)
  }



}
